import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { RouteLink } from '../shared/interfaces/caas/nav.interface';
import { Routes } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class CaasRoutesService {
  routeLinks: BehaviorSubject<RouteLink[]> = new BehaviorSubject<RouteLink[]>(
    []
  );

  /**
   * Set the route links and update the BehaviorSubject.
   * Logs the route links to verify.
   */
  setRouteLinks(routeLinks: RouteLink[]): void {
    if (!routeLinks || !Array.isArray(routeLinks)) {
      console.warn(
        'Invalid routeLinks provided. Expected an array of RouteLink objects.'
      );
      return;
    }
    this.routeLinks.next(routeLinks);
  }

  /**
   * Get the current route links as an observable.
   * Returns an observable for subscription.
   */
  getRouteLinks(): Observable<RouteLink[]> {
    return this.routeLinks.asObservable();
  }

  /**
   * Return the route link by identifier for components outside mainSections.
   * Logs warnings if routes or identifier are missing.
   */
  getSeoRouteByIdentifier(
    identifier: string,
    routes: Routes
  ): RouteLink | undefined {
    if (!routes || !Array.isArray(routes)) {
      console.warn('Invalid routes provided or empty routes array.');
      return undefined;
    }

    if (identifier === '') {
      console.warn('No identifier provided for getSeoRouteByIdentifier.');
      return undefined;
    }

    const matchedRoute = routes
      .filter((route) => route?.path)
      .map((route) => ({
        identifier: route?.data?.['pageIdentifier'],
        path: route?.path || '',
      }))
      .find((route) => route?.identifier === identifier);

    if (!matchedRoute) {
      console.warn(
        `Route with identifier "${identifier}" not found in the provided routes.`
      );
    }

    return matchedRoute;
  }
}
